import { SiteSearchDropdownQuery as QueryTypes } from "coral-admin/__generated__/SiteSearchDropdownQuery.graphql";
import { QueryRenderer } from "coral-framework/lib/relay";
import { Label, Option, SelectField } from "coral-ui/components/v2";
import React, { FunctionComponent, useEffect, useState } from "react";
import { graphql } from "react-relay";
import styles from "./SiteSearchDropdown.css";

interface Props {
  value?: string;
  onChange: (siteID: string) => void;
  disabled?: boolean;
  placeholder?: string;
}
const SiteSearchDropdown: FunctionComponent<Props> = ({
  value,
  onChange,
  disabled,
  placeholder = "Select a site",
}) => {
  const [selectedID, setSelectedID] = useState<string>(value || "");
  useEffect(() => {
    if (value !== undefined) {
      setSelectedID(value);
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newID = e.target.value;
    setSelectedID(newID);
    onChange(newID);
  };

  return (
    <QueryRenderer<QueryTypes>
      query={graphql`
        query SiteSearchDropdownQuery {
          sites {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      `}
      variables={{}}
      render={({ error, props }) => {
        if (error) {
          return <div>Error: {error.message}</div>;
        }

        if (!props) {
          return <div>Loading...</div>;
        }

        // Access the data from props
        const sites = props.sites.edges.map((edge) => edge.node);

        return (
          sites && (
            <div className={styles.root}>
              <Label>Site</Label>

              <SelectField
                value={selectedID}
                onChange={handleChange}
                className={styles.selectField}
                disabled={disabled}
              >
                <Option value="">{placeholder}</Option>

                {sites.map((site, i) => {
                  return (
                    <Option key={site.id} value={site.id}>
                      {site.name}
                    </Option>
                  );
                })}
              </SelectField>
            </div>
          )
        );
      }}
    />
  );
};
export default SiteSearchDropdown;
